import { create } from 'zustand'

export const useGameHelpers = create((set, get) => ({
  // may be easier to have a dictionary to keep it consistent with legalTiles
  // or form legal tiles into an array
  // elements: tile indexes
  tokenChoices: [],
  setTokenChoices: tokenChoices => set(() => ({ tokenChoices })),

  // choice among the choices, 0 if no choice made yet
  // array index
  tokenChoice: 0,
  setTokenChoice: tokenChoice => set(() => ({ tokenChoice })),
  nextTokenChoice: () => set(state => {
    if (state.tokenChoices.length === 0) return { tokenChoice: 0 }
    else if (state.tokenChoice < state.tokenChoices.length - 1) return { tokenChoice: state.tokenChoice + 1 }
    else return { tokenChoice: 0 }
  }),
  prevTokenChoice: () => set(state => {
    if (state.tokenChoices.length === 0) return { tokenChoice: 0 }
    else if (state.tokenChoice > 0) return { tokenChoice: state.tokenChoice - 1 }
    else return { tokenChoice: state.tokenChoices.length - 1 }
  }),
  // nextTokenChoice: () => set(state => ({ tokenChoice: state.tokenChoice + 1 })),

  legalTiles: {},
  setLegalTiles: legalTiles => set(() => ({ legalTiles })),

  tileAnimationRegistry: {},
  registerTileAnimation: ({ tile, context }) => set(state => ({
    tileAnimationRegistry: {
      ...state.tileAnimationRegistry,
      [tile]: context,
    },
  })),
  unregisterTileAnimation: ({ tile }) => set(state => {
    const nextRegistry = { ...state.tileAnimationRegistry }
    delete nextRegistry[tile]
    return { tileAnimationRegistry: nextRegistry }
  }),
}))